<div id='sso-sidebar'>
  <h2 [innerHTML]='header'></h2>
  <div [innerHTML]='safeHtmlBody'></div>
</div>